import { Component, inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { HistoryService } from 'app/core/history.service';
import { Dealer } from 'app/core/model/dealer';
import { InvoicePaymentMethod } from 'app/core/model/invoice-payment-method';
import { Payment } from 'app/core/model/payment';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-payment-history',
    templateUrl: './payment-history.component.html',
    styleUrls: ['./payment-history.component.scss'],
    standalone: false
})
export class PaymentHistoryComponent {
    uow = inject(GenesisUnitOfWork);
    auth = inject(AuthService);
    sessionInfo = inject(SessionInformationService);
    appInfo = inject(AppInformationService);
    router = inject(Router);
    historyService = inject(HistoryService);
    modalService = inject(BsModalService);

    payments: Payment[];
    filter: any;
    dealers: Dealer[];
    paymentMethods: InvoicePaymentMethod[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    onExporting = SharedModule.onExporting;

    async ngOnInit() {
        this.dealers = (await this.uow.getDealers(true)) as Dealer[];
        this.paymentMethods = (await this.uow.invoicePaymentMethods.whereActive('displayOrder')) as InvoicePaymentMethod[];
        const filter = this.sessionInfo.getItem('payment-history-filter');
        if (filter) {
            this.filter = filter;
            await this.search();
        } else this.filter = {};
    }

    async search() {
        this.appInfo.pleaseWaitShow();
        this.sessionInfo.setItem('payment-history-filter', this.filter);
        this.payments = await this.historyService.getPaymentHistory(this.filter);
        this.appInfo.pleaseWaitHide();
    }

    clear() {
        this.sessionInfo.removeItem('payment-history-filter');
        this.filter = { includeDeleted: false };
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async rowDoubleClick(e) {
        if (!e.data?.id) return;
        await this.open(e.data.id);
    }

    async open(paymentId: number) {
        if (!paymentId) return;
        this.router.navigate([`/payments/${paymentId}`]);
    }
}
